import Colors from '@utils/Colors.js'

import {field, formSpacing} from '../UI/forms/styles.js'

// The sizes and colours of the SearchBar that aren't form field tokens (those come from UI/forms/styles.ts)

export const searchBar = {
    // The bar keeps room for its fields in a header full of buttons
    minWidth: 300,
    minWidthWithDate: 530,
    // Space to the buttons next to it in the header
    marginRight: formSpacing.columnGap,
    dateWidth: 200,
    searchMaxWidth: 400,
    // Space under the fields while the search field is shown (the headers are laid out with it, the time slider
    // moves up into it)
    searchPaddingBottom: 10,
    // The icon buttons in the search field: smaller than a standalone IconButton so they fit the field's height
    iconButtonSize: 28,
    // Box padding next to the icon buttons, so the icons sit where the 20px icons with 10px padding were
    boxPaddingX: field.paddingX - 4,
    menuMaxHeight: 400,
    // The time slider sits closer to the fields than a form row gap
    timeSliderMarginTop: -10
}

export const chip = {
    height: 40,
    paddingX: 15,
    radius: 20,
    // The operator icon, the text inherits the page font size
    operatorFontSize: 15,
    background: Colors.grey20,
    color: Colors.textDark,
    // Same raised look as the Slider handles
    shadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0,0,0,.12)',
    // The chips row below the header: chips are formSpacing apart and from the edges
    gap: formSpacing.columnGap
}
